import Link from 'next/link'
import Fade from 'react-reveal/Fade'

import Button from 'components/hong-kong-dial/Button'
import Header from 'components/hong-kong-dial/Header'
import TESpacer from 'components/hong-kong-dial/Spacer'
import Subheader from 'components/hong-kong-dial/Subheader'

import { Main, Root, Spacer } from './Footer.style'
import Dial from './dial.svg'
import Diameter from './diameter.svg'
import Material from './material.svg'
import Movement from './movement.svg'
import Thickness from './thickness.svg'

const Footer = () => {
  return (
    <Root>
      <Main>
        <Fade>
          <Header className="text-center">Specifications</Header>
          <Spacer />
          <Spacer />
          <div className="w-full grid grid-cols-2 md:grid-cols-5 gap-x-4 gap-y-12 justify-items-center text-center">
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Diameter className="w-full h-auto" />
              </div>
              <Subheader>Diameter</Subheader>
              <p className="block mt-2 uppercase text-sm">35MM</p>
            </div>
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Thickness className="w-full h-auto" />
              </div>
              <Subheader>Thickness</Subheader>
              <p className="block mt-2 uppercase text-sm">8.10MM</p>
            </div>
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Dial className="w-full h-auto" />
              </div>
              <Subheader>Case</Subheader>
              <p className="block mt-2 uppercase text-sm">
                316L
                <br />
                Stainless Steel
              </p>
            </div>
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Material className="w-full h-auto" />
              </div>
              <Subheader>Dial Material</Subheader>
              <p className="block mt-2 uppercase text-sm">Semi Matte Lacquer on Brass</p>
            </div>
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Movement className="w-full h-auto animate-spin-slow" />
              </div>
              <Subheader>Movement</Subheader>
              <p className="block mt-2 uppercase text-sm">ETA 955.112</p>
            </div>
          </div>
          <Spacer />
          <Spacer />
          <Header className="text-center">How To Purchase</Header>
          <Spacer />
          <div className="text-center">
            <Button role="button" as={Link} href="https://www.thearmoury.com/collections/paulin">
              Shop now
            </Button>
          </div>
        </Fade>
      </Main>
      <TESpacer />
    </Root>
  )
}

Footer.propTypes = {}

Footer.defaultProps = {}

export default Footer
